import { FC } from "react";
import Image from "next/image";
import GenerateUID from "@/utils/generateUID";
import { ChipType } from "@/types/data/data.types";

interface TChipProps {
  chip: ChipType[];
}

const Chip: FC<TChipProps> = ({ chip }: TChipProps) => {
  // Tri des éléments par la propriété " manufacturer "
  const sortedChips = [...chip].sort((a, b) => a.manufacturer.localeCompare(b.manufacturer));

  return (
    <div>
      {sortedChips.map((c: ChipType, i: number) => {
        return (
          <div key={`${i}-${GenerateUID()}`} className='w-full'>
            {c.img && (
              <p className='flex gap-2 w-full'>
                <Image
                  src={`/data/image/${c.img}`}
                  width={0}
                  height={0}
                  alt={c.name}
                  className='flex gap-2 w-10 h-auto'
                />
                <span className='text-sm'>{c.name}</span>
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Chip;
